import axios from "./http";

let baseUrl = "";

// 条形码设置
export function getBarcode(params) {
  return axios.get(`${baseUrl}/syapi/config/barcode?type=3`,params);
}

// 小票字段
export function getReceiptField() {
  return axios.get(`${baseUrl}/syapi/config/receiptField`);
}

// 标价签字段
export function bidPriceField() {
  return axios.get(`${baseUrl}/syapi/config/bidPriceField`);
}
// 条码字段
export function barcodeField() {
  return axios.get(`${baseUrl}/syapi/config/barcodeField`);
}
// 小票打印内容保存
export function receiptsave(data) {
  return axios.post(
    `${baseUrl}/syapi/config/receiptsave`,
    data
    // qs.stringify(data, { indices: false })
  );
}

// 标价签打印内容保存
export function bidpricesave(data) {
  return axios.post(`${baseUrl}/syapi/config/bidpricesave`, data);
}
// 条码标签字段保存
export function barcodeFieldSave(data) {
  return axios.post(`${baseUrl}/syapi/config/barcodeFieldSave`, data);
}

// 抹零方式
export function zerotype() {
  return axios.get(`${baseUrl}/syapi/config/zerotype`);
}

// 抹零方式设置
export function zerotypesave(params) {
  return axios({
    url: `${baseUrl}/syapi/config/zerotypesave`,
    method: "get",
    params,
  });
}

// 副屏广告保存
export function secondscreenad() {
  return axios({
    url: `${baseUrl}/syapi/config/secondscreenad`,
    method: "get",
  });
}

// 副屏广告保存
export function secondscreenadsave(data) {
  return axios({
    url: `${baseUrl}/syapi/config/secondscreenadsave`,
    method: "post",
    data,
  });
}

// 副屏广告删除
export function secondscreenaddel(data) {
  return axios({
    url: `${baseUrl}/syapi/config/secondscreenaddel`,
    method: "post",
    data,
  });
}
// 获取主题颜色 收款按钮背景色 主题字体颜色
export function getColorConfig() {
  return axios({
    url: `${baseUrl}/syapi/config/color`,
    method: "get",
  });
}
// 设置主题颜色 收款按钮背景色 主题字体颜色
export function setCOlorConfig(data) {
  return axios({
    url: `${baseUrl}/syapi/config/colorSave`,
    method: "post",
    data,
  });
}
// 获取打印机信息ev
export function getDeviceInfo() {
  return axios({
    url: `${baseUrl}/syapi/config/portSet`,
    method: "get",
  });
}
// 保存打印机信息
export function setDeviceInfo(data) {
  return axios({
    url: `${baseUrl}/syapi/config/portSetSave`,
    method: "post",
    data,
  });
}
// 获取logo
getLogo
export function getLogo() {
  return axios({
    url: `${baseUrl}/syapi/config/baseic`,
    method: "get",
  });
}



// WEBPACK FOOTER //
// ./src/api/system-set.js